import Head from 'next/head'
import { MinimalHeaderWithLogout } from '@/elements/header/MinimalHeaderWithLogout'
import { DSSpacer } from '@/components/ds/Spacer/Spacer'
import React from 'react'
import { BreakConfigProps, DSGrid } from '@/components/ds/Grid/Grid'
import { DSGridBlock } from '@/components/ds/Grid/Grid'
import Link from 'next/link'
import { DSTextAndIcon } from '@zoe/ds-web'
import { usePathname } from 'next/navigation'
import { LoadingSpinner } from '@/components/shared/LoadingSpinner'
import { Footer } from '@/components/elements/footer/Footer'
import { useSetTrackingSection } from '@/lib/hooks/useSetTrackingSection'
import { Header } from '@/components/elements/header/Header'
import { trackCtaClick } from '@/lib/gtm/gtmV2'
import { useAuth } from '@/lib/hooks/useAuth'
const breakConfig: BreakConfigProps = {
  s: { colSpan: 2 },
  m: { colSpan: 4, offset: 1 },
  l: { colSpan: 6, offset: 3 },
  xl: { colSpan: 6, offset: 3 },
}

interface AccountPageWrapperProps {
  children: React.ReactNode
  loading?: boolean
}

export function AccountPageWrapper({ children, loading }: AccountPageWrapperProps) {
  const path = usePathname()
  useSetTrackingSection('account')

  const { logout } = useAuth()

  const handleLogout = () => {
    logout()
    trackCtaClick('account', 'logout-button')
  }

  return (
    <>
      <Head>
        <title>ZOE - Account</title>
        <link rel="icon" href="/favicon.png" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta name="robots" content="noindex,nofollow" />
      </Head>

      <Header secondaryCtaLabel="Logout" onSecondaryCtaPress={handleLogout} />

      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <DSSpacer size={96} direction="vertical" />

          <DSGrid>
            <DSGridBlock breakConfig={breakConfig}>
              {path != '/account' && (
                <>
                  <DSSpacer size={16} direction="vertical" />
                  <Link href="../account" passHref>
                    <DSTextAndIcon
                      icon={{
                        name: 'chevron-left',
                        position: 'left',
                        size: 16,
                        color: 'link',
                      }}
                      color="link"
                      weight="semiBold"
                      variant="fluid-paragraph-200"
                    >
                      Back
                    </DSTextAndIcon>
                  </Link>
                  <DSSpacer size={24} direction="vertical" />
                </>
              )}
              {children}
            </DSGridBlock>
          </DSGrid>

          <DSSpacer size={32} direction="vertical" />

          <Footer />
        </>
      )}
    </>
  )
}
